import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

// Wave-17 Item 1.1 — Owner DocumentList lazy-loaded.
export const Route = createFileRoute("/owner_/$token/list")({
  component: lazyRouteComponent(
    () => import("@/pages/Owner/DocumentList/Container"),
  ),
});
